import { render, staticRenderFns } from "./conversation-list.vue?vue&type=template&id=21d33dc6&scoped=true"
import script from "./conversation-list.vue?vue&type=script&lang=js"
export * from "./conversation-list.vue?vue&type=script&lang=js"
import style0 from "./conversation-list.vue?vue&type=style&index=0&id=21d33dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d33dc6",
  null
  
)

export default component.exports